import { createContext } from 'react';

export const FormikStepperContext = createContext(null);